var a = /* @__PURE__ */ ((e) => (e.EventFileDownload = "file_download", e.EventGenerateLead = "generate_lead", e.EventSearch = "search", e.EventShare = "share", e.EventViewItem = "view_item", e))(a || {});
export {
  a as TrackEventSubType
};
